import type { FaireProductEntity } from "../../entity_types/product";

export const p_huxr8shjm9: FaireProductEntity = {
  token: "p_huxr8shjm9",
  type: "product",
  name: "XOXO YOUTH",
  brandToken: "b_4adj9wfm65",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a24fec049f479845a81d862608bea30d81372b22511e2ebe09347e1bd58fe10e.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.95,
  description:
    "Discover the XOXO Youth tee from Glittering South, your go-to for custom made apparel. This unisex graphic tee, shown in white, is a classic addition to any child's wardrobe. Perfect for loungewear, its timeless design can be enjoyed in the fall/winter season. Made with a unisex fit for versatility, simply machine wash to keep it fresh and ready for your next cosy day in. With Glittering South, your kids' t-shirt needs become a reality!",
  tags: [],
  msrpDollars: 35.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:50.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
